'use strict';

var $backToTopIcon = $('.back-to-top-container .icon');
var $accordionHeader = $('.footer-accordion-header');
var $accordionBody = $('.footer-accordion-body');

$(document).ready(function () {
    $accordionHeader.on('click', function () {
        if (!app.checkBreakPoint('lg')) {
            var $this = $(this);
            if ($this.hasClass('accordion-open')) {
                $this.parent().find('.footer-accordion-body').slideUp();
                $this.removeClass('accordion-open');
            } else {
                $accordionBody.slideUp();
                $accordionHeader.removeClass('accordion-open');
                $this.parent().find('.footer-accordion-body').slideToggle();
                $this.addClass('accordion-open');
            }
        }
    });

    $backToTopIcon.on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow'); // Smooth scrolling
        return false;
    });
});
